export const EXCLUDE_BOOTSTRAP_ROUTES = [
	"/",
	"/jobs",
	"/companies",
	"/companies/:id",
	"/companies/:id/embed",
	"/companies/:id/claim",
	"/company/dashboard",
	"/company/dashboard/:tab",
	"/company/setup",
	"/company/upgrade",
	"/jobs/:id",
	"/profile",
	"/payments",
	"/forgot-password",
	"/fitcheckme",
	"/fitchecks",
	"/applications",
	"/register",
	"/register/create-account",
	"/signin",
	"/creating-profile",
	"/for-employers",
	"/claim-mini-landing",
	"/about-us",
	"/help-&-support",
	"resume-tips",
	"/articles",
	"/app-auth",
	"/articles/:id",
	"/articles/:id/:slug",
	"/control-center/opportunities",
	"/control-center/opportunity-details",
	"/onboarding",
];
